module.exports = __webpack_public_path__ + "img/brain.a4bc2b3a.svg";